<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('visitation.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('visitation.pageTitle'),
            href: '/admin/visitation-route-plans'
          },
          {
            text: $t('create'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <ts-loading-banner :loading="loading">
          <div class="ts-space-y-4">
            <div class="row">
              <div class="col-md-4">
                <div class="row">
                  <!-- <div class="col-md-6">
                    <label class="required">{{ $t('visitation.date') }}</label>
                    <a-date-picker
                      v-model="model.plan_date"
                      format="DD-MM-YYYY"
                      valueFormat="DD-MM-YYYY"
                      class="ts-w-full"
                    ></a-date-picker>
                    <div class="validate" v-if="errors.has('plan_date')">
                      {{ errors.first('plan_date') }}
                    </div>
                  </div> -->
                  <div class="col-md-12">
                    <label class="required">{{
                      $t('visitation.saleName')
                    }}</label>
                    <a-select
                      show-search
                      v-model="model.sale_id"
                      style="width: 100%"
                      :default-active-first-option="false"
                      :show-arrow="false"
                      :filter-option="false"
                      :not-found-content="null"
                      :placeholder="$t('visitation.typeToSearch')"
                      :filterOption="
                        (input, option) =>
                          option.componentOptions.children[0].text
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                      "
                      @change="onSaleChange"
                    >
                      <a-select-option v-for="s in saleUser" :key="s.user_id">
                        {{ s.name }}
                      </a-select-option>
                    </a-select>
                    <div class="tw-text-red-500" v-if="errors.has('sale_id')">
                      {{ errors.first('sale_id') }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-8 ts-flex ts-items-end">
                <div class="ts-flex ts-space-x-3 ts-h-8 ts-mb-1">
                  <ts-button
                    color="primary"
                    outline
                    @click.prevent="onSaveAddNew"
                    >{{ $t('save_add_new') }}</ts-button
                  >
                  <ts-button color="primary" @click.prevent="onSave">{{
                    $t('save')
                  }}</ts-button>
                  <ts-button
                    @click.prevent="$router.push({ name: 'visitation-plan' })"
                  >
                    {{ $t('cancel') }}
                  </ts-button>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <ProvinceSearch
                  v-model="model"
                  :items="provinces"
                  @itemCheck="onProvinceChange"
                />
              </div>
              <div class="col-md-4">
                <DistrictSearch
                  v-model="model"
                  @loading="v => (loading = v)"
                  @itemCheck="onDistrictChange"
                  ref="district_search"
                />
              </div>
              <div class="col-md-4">
                <CommuneSearch
                  v-model="model"
                  ref="commune_search"
                  @loading="v => (loading = v)"
                  @itemCheck="onCommuneChange"
                />
              </div>
              <!-- <div class="col-md-12">
                <div
                  class="ts-flex ts-justify-end ts-mt-3 ts-items-center ts-space-x-3"
                >
                  <h5 class="ts-mb-0">{{ $t('visitation.totalShopPlan') }}</h5>
                  <input
                    type="text"
                    class="form-control"
                    style="width: 80px"
                    readonly
                    :value="shopList.length"
                  />
                  <ts-button color="primary">{{
                    $t('visitation.assign')
                  }}</ts-button>
                </div>
                <ShopSearch
                  @loading="v => (loading = v)"
                  @fetchShop="onFetchShop"
                  ref="shop_search"
                  v-model="model"
                />
              </div> -->
            </div>
            <hr />
            <div class="row">
              <div class="col-md-2">
                <label class="ts-mb-0">{{
                  $t('visitation.totalShopPlan')
                }}</label>
                <input
                  type="text"
                  class="form-control"
                  readonly
                  :value="shopList.length"
                />
              </div>
              <div class="col-md-2">
                <label class="ts-mb-0">{{
                  $t('visitation.numberOfShopVisitPerDay')
                }}</label>
                <input
                  v-model="visit_per_day"
                  type="number"
                  class="form-control"
                  @input="onNumberOfShopVisitPerDay"
                />
              </div>
              <div class="col-md-2">
                <label class="ts-mb-0">{{ $t('visitation.duration') }}</label>
                <select class="form-control">
                  <option :value="15">15 minute</option>
                  <option :value="30">30 minute</option>
                  <option :value="60">60 minute</option>
                  <option :value="90">90 minute</option>
                  <option :value="120">120 minute</option>
                  <option :value="150">150 minute</option>
                  <option :value="180">180 minute</option>
                </select>
              </div>
              <div class="col-md-2">
                <label class="ts-mb-0 required">{{
                  $t('visitation.startDate')
                }}</label>
                <a-date-picker
                  v-model="start_date"
                  :allowClear="false"
                  format="DD-MM-YYYY"
                  valueFormat="DD-MM-YYYY"
                  class="ts-w-full"
                  @change="applyDateAndMinute"
                ></a-date-picker>
              </div>
              <div class="col-md-2">
                <label class="ts-mb-0 required">{{
                  $t('visitation.endDate')
                }}</label>
                <a-date-picker
                  v-model="end_date"
                  format="DD-MM-YYYY"
                  valueFormat="DD-MM-YYYY"
                  :disabled="true"
                  class="ts-w-full"
                ></a-date-picker>
              </div>
              <div class="col-md-2">
                <ts-button
                  color="primary"
                  class="ts-mt-4"
                  @click.prevent="applyDateAndMinute"
                  >{{ $t('visitation.apply') }}</ts-button
                >
              </div>
            </div>
            <div class="row">
              <table class="ts-w-full">
                <thead>
                  <tr>
                    <th
                      class="ts-w-4 ts-uppercase ts-bg-gray-200 ts-py-1 ts-px-2"
                    >
                      <input
                        type="checkbox"
                        :checked="isCheckAll"
                        @change="onCheckAll"
                      />
                    </th>
                    <th class="ts-uppercase ts-bg-gray-200 ts-py-1 ts-px-2">
                      {{ $t('visitation.shopName') }}
                    </th>
                    <th class="ts-uppercase ts-bg-gray-200 ts-py-1 ts-px-2">
                      {{ $t('visitation.date') }}
                    </th>
                    <th class="ts-uppercase ts-bg-gray-200 ts-py-1 ts-px-2">
                      {{ $t('visitation.duration') }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(s, index) in shopList"
                    :key="index"
                    class="ts-border-b"
                  >
                    <td class="ts-py-1 ts-px-2">
                      <input 
                        v-model="s.is_check" 
                        type="checkbox"
                      />
                    </td>
                    <td class="ts-py-1 ts-px-2">
                      {{ s.customer_name + '-' + s.commune_code + '-' + s.cname_kh }} 
                        <span class="ts-text-blue-700">{{ s.cname }}</span>
                    </td>
                    <td class="ts-py-1 ts-px-2">
                      <a-date-picker
                        v-model="s.plan_date"
                        format="DD-MM-YYYY"
                        valueFormat="DD-MM-YYYY"
                        class="ts-w-full"
                        :allowClear="false"
                      ></a-date-picker>
                    </td>
                    <td class="ts-py-1 ts-px-2">
                      <select class="form-control" v-model="s.duration">
                        <option :value="15">15 minute</option>
                        <option :value="30">30 minute</option>
                        <option :value="60">60 minute</option>
                        <option :value="90">90 minute</option>
                        <option :value="120">120 minute</option>
                        <option :value="150">150 minute</option>
                        <option :value="180">180 minute</option>
                      </select>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- <TableList v-model="model" /> -->
            <!-- <ViewMap v-model="model" /> -->
          </div>
        </ts-loading-banner>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import moment from 'moment'
import { Errors } from 'form-backend-validation'
import CommuneSearch from './components/commune-search.vue'
import ProvinceSearch from './components/province-search.vue'
import DistrictSearch from './components/district-search.vue'
// import ShopSearch from './components/shop-search.vue'
// import ViewMap from './components/view-map-create-update.vue'
// import TableList from './components/table-list.vue'
import { mapActions } from 'vuex'
import { cloneDeep } from 'lodash' 
export default {
  name: 'visitationPlan',
  components: {
    ProvinceSearch,
    DistrictSearch,
    CommuneSearch
    // ShopSearch
    // ViewMap,
    // TableList
  },
  data() {
    return {
      errors: new Errors(),
      loading: false,
      saleUser: [],
      provinces: [],
      selectedProvince: [],
      selectedDistricts: [],
      selectedCommunes: [],
      model: {
        sale_id: null,
        plan_date: moment().format('DD-MM-YYYY'),
        customer_list: []
      },
      shopList: [],
      start_date: moment().format('DD-MM-YYYY'),
      end_date: undefined,
      duration: 15,
      visit_per_day: 0
    }
  },
  created() {
    this.fetchSale()
  },
  computed: {
    isCheckAll() {
      return (
        this.shopList.filter(s => s.is_check == true).length ==
        this.shopList.length
      )
    }
  },
  methods: {
    ...mapActions('customer/visitation', ['getFormViewModel', 'getShop']),
    fetchSale() {
      this.loading = false
      this.getFormViewModel({
        fnName: 'sale'
      })
        .then(response => {
          this.saleUser = response.data['sale']
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    onSaleChange(value) {
      this.loading = true
      this.getFormViewModel({
        sale_id: value,
        fnName: 'province'
      })
        .then(response => {
          this.provinces = response.data['province']
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    onProvinceChange(provinceCode) {
      this.selectedProvince = provinceCode
      this.$refs.district_search.items = []
      this.$refs.district_search.checkedItem = []
      this.$refs.commune_search.items = []
      this.$refs.commune_search.checkedItem = []
      if (!provinceCode.length) {
        // this.$refs.shop_search.customers = []
        this.shopList = []
        return
      }
      this.$refs.district_search.fetchDistrict({ provinceCode: provinceCode })
    },
    onDistrictChange(districtCode) {
      this.selectedDistricts = districtCode
        ? districtCode
        : this.$refs.district_search.checkedItem
      this.$refs.commune_search.items = []
      this.$refs.commune_search.checkedItem = []
      if (!districtCode.length) {
        // this.$refs.shop_search.customers = []
        this.shopList = []
        return
      }
      this.$refs.commune_search.fetchCommune({ districtCode: districtCode })
    },
    onCommuneChange(communeCode) {
      this.selectedCommunes = communeCode
      if (!communeCode.length) {
        // this.$refs.shop_search.customers = []
        this.shopList = []
        return
      }
      this.onFetchShop()
    },
    async onFetchShop() {
      this.loading = true
      let response = await this.getShop({
        province_code: this.selectedProvince,
        district_code: this.selectedDistricts,
        commune_code: this.selectedCommunes
      })
      this.loading = false
      this.shopList = response.data
      this.shopList.forEach(el => {
        el.is_saved = false
        el.is_check = false
        el.plan_date = ''
        el.duration = this.duration
      })
    },
    onSave() {
      this.loading = true
      this.errors = new Errors()
      this.$store
        .dispatch('customer/visitation/store', this.filterData())
        .then(response => {
          this.$toasted.success(response.message)
          this.$router.push({ name: 'visitation-plan' })
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.loading = false
        })
    },
    onSaveAddNew() {
      this.loading = true
      this.errors = new Errors()
      this.$store
        .dispatch('customer/visitation/store', this.filterData())
        .then(response => {
          this.$toasted.success(response.message)
          this.clearInput()
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.loading = false
        })
    },
    filterData() {
      return {
        data: this.shopList
          .filter(d => d.is_check == true)
          .map(el => ({
            sale_id: this.model.sale_id,
            plan_date: el.plan_date,
            customer_id: el.customer_id,
            duration: el.duration
          }))
      }
    },
    clearInput() {
      this.model.sale_id = null
      this.model.plan_date = moment().format('DD-MM-YYYY')
      this.model.customer_list = []
      this.shopList = []
      this.start_date = moment().format('DD-MM-YYYY')
      this.end_date = undefined
      this.duration = 15
      this.visit_per_day = 0
    },
    onNumberOfShopVisitPerDay() {
      if (!this.visit_per_day) {
        this.$toasted.error('Number of shop visit per day is zero or blank!')
        return
      }
      this.end_date = moment(this.start_date, 'DD-MM-YYYY')
        .add(this.visit_per_day, 'days')
        .format('DD-MM-YYYY')
    },
    async applyDateAndMinute() {
      if (!this.visit_per_day) {
        this.$toasted.error('Number of shop visit per day is zero or blank!')
        return
      }

      let day = Math.floor(this.shopList.length / this.visit_per_day)
      this.loading = true
      this.shopList = cloneDeep(await this.spliceIntoChunks(this.shopList, day))
      this.loading = false
    },
    async spliceIntoChunks(arr, chunkSize) {
      const res = []
      let indexStart = 1
      const date = moment(this.start_date, 'DD-MM-YYYY')

      while (arr.length > 0) {
        let addDate = date

        if (indexStart > 1 && indexStart < this.visit_per_day) {
          addDate = date.add(1, 'days').format('DD-MM-YYYY')
        } else if (indexStart >= this.visit_per_day) {
          addDate = this.end_date
        } else {
          addDate = date.format('DD-MM-YYYY')
        }

        const chunk = arr.splice(0, chunkSize)
        chunk.forEach(el => {
          el.is_check = true
          el.plan_date = addDate
        })
        res.push(...chunk)
        indexStart++
      }
      return res
    },
    onCheckAll(e) {
      if (e.target.checked) {
        this.shopList.forEach(element => {
          element.is_check = true
        })
      } else {
        this.shopList.forEach(element => {
          element.is_check = false
        })
      }
    }
  }
}
</script>
